(() => {
  const config = JSON.parse(document.getElementById('bb-payment-config')?.textContent || '{}');
  const pixPercent = config.pixEnabled === false ? 0 : Math.max(0, Math.min(50, Number(config.pixPercent ?? 10)));
  const countFor = amount => {
    if (config.installmentsEnabled === false) return 1;
    const maximum = Math.max(1, Math.min(12, Number(config.installments ?? 6)));
    return config.minimum > 0 ? Math.max(1, Math.min(maximum, Math.floor(amount / config.minimum))) : maximum;
  };
  const money = amount => new Intl.NumberFormat(config.locale || 'pt-BR', {style:'currency',currency:config.currency || 'BRL'}).format(amount / 100);
  const terms = (amount, full = false) => {
    const count = countFor(amount);
    if (count <= 1) return pixPercent > 0 ? `${money(amount)} ${config.card || 'no cartão'}` : '';
    const before = (full ? config.before || 'em [count]x de' : config.onlyBefore || '[count]x de').replace('[count]', count);
    return `${full ? money(amount) + ' ' : ''}${before} ${money(Math.round(amount/count))} ${config.after || 'sem juros'}`;
  };
  window.BlocoboxPayments = {pixPercent,countFor,terms,money};
  if (!customElements.get('bb-payment-terms')) customElements.define('bb-payment-terms', class extends HTMLElement {
    static get observedAttributes() { return ['data-amount']; }
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      document.forms.namedItem(this.getAttribute('form'))?.addEventListener('variant:change', event => {
        this.hidden = !event.detail.variant;
        if (event.detail.variant) this.setAttribute('data-amount', event.detail.variant.price);
      }, {signal:this.controller.signal});
      this.update();
    }
    attributeChangedCallback() { this.update(); }
    update() {
      const amount = Number(this.dataset.amount);
      if (!Number.isFinite(amount)) return;
      this.textContent = terms(amount, this.dataset.full === 'true');
      this.hidden = !this.textContent;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
})();
